import type { ReactNode } from "react";
import styles from "./ColouredWords.module.css";

export type Side = "incoming" | "existing";

export function Named({
  side,
  bold = false,
  children,
}: {
  side: Side;
  bold?: boolean;
  children: ReactNode;
}) {
  return (
    <span className={bold ? `${styles.named} ${styles.bold}` : styles.named} data-side={side}>
      {children}
    </span>
  );
}

function sideOfWord(word: string): Side | null {
  if (/^source('s)?$/.test(word)) return "incoming";
  if (/^target('s)?$/.test(word)) return "existing";
  return null;
}

export function ColouredWords({ text, bold = false }: { text: string; bold?: boolean }) {
  return (
    <>
      {text.split(/\b(source's|target's|source|target)\b/).map((part, index) => {
        const side = sideOfWord(part);
        return side ? (
          <Named key={`${index}-${part}`} side={side} bold={bold}>
            {part}
          </Named>
        ) : (
          part
        );
      })}
    </>
  );
}
